<template>
    <vx-card no-shadow>
        <h4 class="pt-2">Convidar</h4>
        
            <div class="mb-4 flex flex-wrap">

                <div class="m-6" ref="qrcode"></div>

                <div class="ml-4 py-6" style="row-gap: 12px; display: flex; flex-direction: column">
                    <div>Envie este link-convite para o colaborador:</div>
                    <a :href="inviteUrl"><h4 class="text-danger" >{{inviteUrl}}</h4></a>
                    <div class="flex share-buttons">

                        <vs-button color="success" type="filled" style="height: 42px"
                            @click="() => modal.whatsapp.visible = true">
                            <div class="flex" style="align-items: center; column-gap: 8px;">
                                <vue-mdi icon="whatsapp" color="#fff"/>
                                Whatsapp
                            </div>
                        </vs-button>
                        <vs-button color="primary" type="border" style="height: 42px"
                            @click="downloadQrCode">
                            <div class="flex" style="align-items: center; column-gap: 8px;">
                                <vue-mdi icon="download" color="red"/>
                                Download p/ impressão
                            </div>
                        </vs-button>
                    </div>
                </div>

            </div>

        <vs-divider border-style="dashed" class="mb-8"> 
        </vs-divider>

        <h4 class="pt-2">Gerenciar colaboradores</h4>

        <div class="flex">
            <div class="w-full">
                <employees-added @change="(value) => employees = value" />
            </div>
        </div>

        <a-modal v-model="modal.whatsapp.visible" title="Insira o número" ok-text="Enviar" cancel-text="Cancelar"
            @ok="sendWhatsapp"
            :okButtonProps="{ props: { disabled: invalidPhone } }"
        >
            Digite o número do colaborador, com DDD
            <the-mask mask="(##) #####-#### " type="text" :masked="false"
                :value="modal.whatsapp.number"
                v-show="false"
                @input="(v) => modal.whatsapp.unmasked = v"></the-mask>
            <vs-input v-mask="'(##) #####-####'" class="mt-2"
                :danger="invalidPhone"
                danger-text="Não é um telefone válido"
                placeholder="(00) 9 9999-9999" 
                v-model="modal.whatsapp.number" />
        </a-modal>
        <QrCodeDownload ref="qrcodeDownloader" :qrcodeText="inviteUrl"/>
    </vx-card>
</template>

<script>
import firebase from '@/firebase/firebase'
import EmployeesAdded from './EmployeesAdded'
import QrCodeDownload from './QrCodeDownload';
import * as qrCode from 'easyqrcodejs'
import { mask, TheMask } from 'vue-the-mask'

export default {
    directives : {mask},
    components : {
        EmployeesAdded,
        TheMask,
        QrCodeDownload,
    },

    data () {
        return {
            ref : firebase.firestore(),
            email : '',
            employees : '',
            modal: {
                whatsapp: {
                    visible: false,
                    number: '',
                    unmasked: ''
                }
            }
        }
    },

    computed : {
        invalidPhone () {
            return this.modal.whatsapp.number.length < 15;
        },
        inviteUrl () {
            const companyId = this.$store.getters.getCompanyID;
            return `https://painel.pedidorapido.app/invitation/${companyId}`
        }
    },

    methods : {
        mountQrCode () {
            let qrCodeOpts = {
                text : this.inviteUrl,
                width: 160,
                height: 160,
                logoWidth: 60, 
                logoHeight: 60,
                logoBackgroundTransparent:true,
            }
          new qrCode(this.$refs.qrcode, qrCodeOpts)
        },
        sendWhatsapp () {
            const message = `Olá! Você recebeu um convite para ingressar no Pedido Rápido. Clique neste linkl para criar sua conta: ${this.inviteUrl}`;
            window.open(`https://api.whatsapp.com/send?phone=55${this.modal.whatsapp.number}&text=${encodeURI(message)}`)
            this.modal.whatsapp.visible = false
        },
        downloadQrCode () {
            this.$refs.qrcodeDownloader.download();
        }
    },
    mounted () {
        this.mountQrCode();
    }
}
</script>
<style scoped>
.share-buttons {
    height: 100%;
    align-items: flex-end;
    column-gap: 8px
}
</style>